import {useMediaQuery} from '@vueuse/core'

// Match the Vue 2 capture layout's explicit short phone-landscape viewport.
export const isPhoneLandscapeViewport = (width:number,height:number) => width <= 950 && height <= 520 && width > height
export const phoneLandscapeMedia = '(max-width: 950px) and (max-height: 520px) and (orientation: landscape)'
// Setup already switches to its small-screen layout at 900px. Its drawer and
// breadcrumb trigger must use the same range, including wider landscape phones.
export const compactNavigationMedia = `(max-width: 900px), ${phoneLandscapeMedia}`
export const useCompactPageNavigation = () => useMediaQuery(compactNavigationMedia)
